module.exports = __webpack_public_path__ + "img/mosquito.6dfba405.svg";